"use client";

import { ExpansionPanel } from "@jetblue/kit/expansion-panel";

import type { InfoAccordionItemDialog } from "../../../dialogs/info/accordion";
import { InfoRichTextEditor } from "../rich-text-editor/rich-text-editor";

type InfoAccordionItemProperties = {
  buttonText: InfoAccordionItemDialog<string>[string]["buttonText"];
  content: InfoAccordionItemDialog<string>[string]["content"];
};

type InfoAccordionAreaOverwrittenProperties = {
  id: string;
  isExpanded: boolean;
  isLastPanel: boolean;
  setIsExpanded: (id: string) => void;
  variant?: "primary" | "secondary";
};

export const InfoAccordionItem = ({
  buttonText,
  content,
  id,
  isExpanded,
  isLastPanel,
  setIsExpanded,
  variant = "secondary",
}: InfoAccordionItemProperties & InfoAccordionAreaOverwrittenProperties) => (
  <ExpansionPanel
    buttonClassName="cursor-pointer"
    header={<h3>{buttonText}</h3>}
    id={id}
    isExpanded={isExpanded}
    isLastPanel={isLastPanel}
    setIsExpanded={setIsExpanded}
    variant={variant}
  >
    <InfoRichTextEditor
      className="
        mt-0! pt-4

        [&>*:first-child]:mt-0
      "
      content={content}
    />
  </ExpansionPanel>
);
